import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CCrud from "components/Molecules/Crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";
import { detailsData } from "./details";
import { useEffect } from "react";

const BannersTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  setOpenDeleteModal,
  handleDeleteRequest,
  selectedRow,
  can_create,
  options,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [supportedLang] = useState("en");

  const [isClickable, setIsClickable] = useState(false);

  useEffect(() => {
    setIsClickable(selectedRow?.formikData?.values?.need_action);
  }, [selectedRow?.formikData?.values?.need_action]);

  const selectedDataType = selectedRow?.formikData?.values?.data;

  useEffect(() => {
    if (selectedRow?.formikData) {
      const formik = selectedRow.formikData;
      if (formik.values.data !== formik.initialValues.data) {
        formik.setFieldValue("data_id", "");
      }
    }
  }, [selectedDataType, selectedRow?.formikData]);
  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
          // mb={1}
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          detailsTemplateData={{
            pageTitle: t("featured_ads.details"),
            data: {
              images: [
                { id: 0, img: details?.localized_data?.en?.banner },
                { id: 1, img: details?.localized_data?.ar?.banner },
              ],
              list: detailsData({ data: details, t }),
            },
          }}
          table={{
            list: data,
            listTitle: t("featured_ads.list_title"),
            createBtnTitle: can_create && t("featured_ads.add"),
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: [
              { accessor: "id", Header: "#" },
              {
                accessor: "featuredAdEn",
                Header: t("featured_ads.featured_ad_en"),
              },
              {
                accessor: "featuredAdAr",
                Header: t("featured_ads.featured_ad_ar"),
              },
              { accessor: "data", Header: t("featured_ads.data"), sort: true },
              {
                accessor: "data_id",
                Header: t("featured_ads.data_id"),
              },
              { accessor: "Actions", Header: t("cart_logs.actions") },
            ],
            isSearch: false,
            searchInputPlaceholder: "",
            isChecked: false,
            total_count: count,
            setFilterObj,
            className:
              "organization-table system-configurations-table main-table crud-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            actionsList, //if you want to add custom actions list
            headerChildren,
            details,
            openDeleteModal,
            setOpenDeleteModal,
            handleDeleteRequest,
          }}
          form={{
            initialValues: !id
              ? { is_visible: false, need_action: false }
              : initialValues(details, supportedLang),
            structure: () => structure(supportedLang, isClickable, t, selectedRow?.formikData, options),
            validationSchema: validationSchema,
            deleteFun: deleteFun,
            title: id ? t("featured_ads.edit") : t("featured_ads.add"),
            submitTitle: id
              ? t("admin_users.btn_update")
              : t("admin_users.btn_add"),
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
          }}
          // DetailsComponent={<Details />} //to send details component diff from the default
          modalComponents={modalComponents}
        />
      </Box>
    </>
  );
};

export default BannersTemplate;
